import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M12.05 2.175c5.466 0 9.824 4.429 9.824 9.825 0 5.466-4.428 9.824-9.824 9.825H3.738a.6.6 0 0 1-.451-.194.73.73 0 0 1-.176-.502c0-.066-.002-.178.09-.286l1.312-2.622A9.48 9.48 0 0 1 2.225 12c0-5.467 4.429-9.826 9.825-9.826Zm0 1.187a8.544 8.544 0 0 0-8.571 8.57 8.4 8.4 0 0 0 2.205 5.685l.063.076c.058.081.098.18.115.278.02.12.005.265-.09.378l-.984 2.154h7.262c4.687 0 8.57-3.817 8.57-8.571a8.544 8.544 0 0 0-8.57-8.57Z" stroke="currentColor" stroke-width=".3"/>' }
  })
);